import SwiperSlider from "../components/abstract/SwiperSlider";
import $ from 'jquery';

export default class Slider extends SwiperSlider {
  constructor(element, context) {
    super(element, context);

    const nextButton = this.element.find('.swiper-button-next').get(0);
    const prevButton = this.element.find('.swiper-button-prev').get(0);

    $(() => {
      this.options = {
        effect: "cards",
        direction: 'vertical',
				loop: true,
        cardsEffect: {
          slideShadows: false,
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
      };

        $(() => {
          this.init()
        })
    });
  }
}
